import * as React from "react";
import { useCTAWizard } from "../CTAWizardContext";
import { MissingValueWarning } from "./MissingValueWarning";

export const ReviewStep: React.FC = () => {
  const { definition, label, isPlayer, destinationSummary, missingValueWarning } = useCTAWizard();

  if (!definition) return null;

  return (
    <div className="flex flex-col gap-3">
      <div className="rounded-lg border border-slate-200 divide-y divide-slate-100">
        <div className="flex items-center justify-between gap-4 p-3">
          <span className="text-xs font-bold text-slate-500 uppercase tracking-wide">Button Label</span>
          <span className="text-sm font-medium text-slate-800">{label.trim()}</span>
        </div>
        <div className="flex items-center justify-between gap-4 p-3">
          <span className="text-xs font-bold text-slate-500 uppercase tracking-wide">Type</span>
          <span className="flex items-center gap-2 text-sm font-medium text-slate-800">
            <span className="text-primary">{definition.icon}</span>
            {definition.title(isPlayer)}
          </span>
        </div>
        <div className="flex items-center justify-between gap-4 p-3">
          <span className="text-xs font-bold text-slate-500 uppercase tracking-wide">Destination</span>
          <span className="text-sm font-medium text-slate-800 break-all text-right">{destinationSummary}</span>
        </div>
      </div>
      {missingValueWarning && <MissingValueWarning message={missingValueWarning} className="p-3" />}
    </div>
  );
};
